export const suscription = {
  p1: `أدِر تفاصيل خطتك الحالية واستكشف خيارات ترقية اشتراكك أو تغييره.`,
  p2: `الخطة السنوية`,
  p3: `الخطة الشهرية`,
  p4: `نشط حتى`,
  p5: `لكل غرفة شهريًا`,
  p6: `لكل وحدة إقامة شهريًا`,
  p7: `عدد الإشغال`,
  p8: `لكل إشغال شهريًا`,
  p9: `تحديث الاشتراك`,
  p10: `الخدمات النشطة`,
  p11: `نشط`,
  p12: `غير نشط`,
  p13: `ادعُ نزلاءك إلى تسجيل الوصول عبر WhatsApp بجدولته قبل وصولهم إلى وحدة الإقامة.`,
  p14: `التقييمات`,
  p15: `ادعُ نزلاءك إلى تقييم تجربتهم وعزّز سمعة وحدة إقامتك بتقييمات إيجابية.`,
  p16: `الدخول عن بُعد`,
  p17: `سجّل وأدِر الغرف المزوّدة بأقفال ذكية. واضبط رموز الدخول التي ستُسلَّم إلى النزلاء.`,
  p18: `التحقق من الهوية`,
  p19: `نتحقق من هوية النزلاء بمقارنة صورة الهوية أو جواز السفر بصورة ذاتية مباشرة.`,
  p20: `إدارة الاشتراك وطرق الدفع`,
  p21: `أضف البطاقات أو احذفها حسب الحاجة`,
  p22: `اشتراكك الحالي مجاني`,
  p23: `رقِّ اشتراكك للوصول إلى المزايا المتقدمة.`,
  p24: `ينتهي اشتراكك المجاني خلال`,
  p25: `يوم`,
  p26: `أيام`,
  p27: `لا تفقد الوصول إلى المزايا المتقدمة؛ رقِّ اشتراكك الآن`,
  p28: `خصّص خطتك بخدمات إضافية`,
  p29: `إشغال`,
  p30: `شهر`,
  p31: `التقييمات`,
  p32: `الدخول عن بُعد`,
  p33: `خيمة`,
  p34: `فيلا`,
  p35: `التحقق من الهوية`,
  p36: `إجمالي الإشغال`,
  p37: `يشير إجمالي الإشغال إلى الحد الأقصى لعدد الأشخاص المسموح به في جميع شققك، على سبيل المثال (إذا اخترت 5 شقق، فقد يكون إجمالي الإشغال 20 مكانًا). ويساعدنا تحديد إجمالي الإشغال على إدارة اشتراكك بدقة والامتثال لأنظمة السلامة.`,
  p38: `يشير إجمالي الإشغال إلى الحد الأقصى لعدد الأشخاص المسموح به في فيلتك، على سبيل المثال (إذا اخترت 5 شقق، فقد يكون إجمالي الإشغال 20 مكانًا). ويساعدنا تحديد إجمالي الإشغال على إدارة اشتراكك بدقة والامتثال لأنظمة السلامة.`,
  p39: `يشير إجمالي الإشغال إلى الحد الأقصى لعدد الأشخاص المسموح به في فندقك أو نُزُلك، على سبيل المثال (إذا اخترت 5 شقق، فقد يكون إجمالي الإشغال 20 مكانًا). ويساعدنا تحديد إجمالي الإشغال على إدارة اشتراكك بدقة والامتثال لأنظمة السلامة.`,
  p40: `يشير إجمالي الإشغال إلى الحد الأقصى لعدد الأشخاص المسموح به في مخيّمك، على سبيل المثال (إذا اخترت 5 شقق، فقد يكون إجمالي الإشغال 20 مكانًا). ويساعدنا تحديد إجمالي الإشغال على إدارة اشتراكك بدقة والامتثال لأنظمة السلامة.`,
  p41: `يجب إدخال إجمالي الإشغال لعقاراتك.`,
  p42: `WhatsApp الخاص بـ WACheckin`,
  p43: `WhatsApp Business الخاص بك`,
  p44: `لكل إشغال/شهر`,
  p45: `لكل غرفة/شهر`,
  p46: `سنوي`,
  p47: `تفعيل الاشتراك`,
  p48: `تحديث الاشتراك`,
  p49: `الاشتراك المحدد`,
  p50: `عدد`,
  p51: `غرفة`,
  p52: `وحدة إقامة`,
  p53: `السعر الشهري لكل`,
  p54: `غرف`,
  p55: `وحدات إقامة`,
  p56: `عدد الإشغال المحدد`,
  p57: `السعر الشهري لكل`,
  p58: `إشغال`,
  p59: `نوع الاشتراك`,
  p60: `سنوي`,
  p61: `شهري`,
  p62: `خدمات إضافية:`,
  p63: `لم تُضف أي خدمات`,
  p64: `يُنصح بإضافة خدمة WhatsApp`,
  p65: `التقييمات`,
  p66: `الإجمالي المستحق`,
  p67: `المتابعة إلى الدفع`,
  p68: `تحديث الاشتراك`,
  p69: "روبوت المحادثة",
  
  p70: `الاشتراك`,
  p71: `نشط`,
  p72: `خدمات إضافية اختيارية`,

  p73: `هل لديك عقارات جديدة لإدارتها؟`,

  p74: `تفاصيل تحديثك وخدماتك الجديدة`,
  p75: `تُطبَّق رسوم الخدمات أو العقارات الإضافية بشكل تناسبي، مع مراعاة الأيام المتبقية من الشهر في اشتراكك الحالي.`,
  p76: `وهذا يضمن ألا تدفع إلا مقابل مدة الاستخدام الفعلية حتى تجديد خطتك.`,

  p77: `العقارات المضافة`,
  p78: `خدمات إضافية`,
  p79: `الدخول عن بُعد`,
  p80: `روبوت المحادثة بالذكاء الاصطناعي`,
  p81: `السعر`,
  p82: `سنوي`,
  p83: `شهري`,
  p84: `تحديث الاشتراك`,

  p85: `العقارات المشترَكة`,
  p86: `خدمات إضافية`,
  p87: `لم يتم التعاقد على خدمات إضافية`,
  p88: `روبوت المحادثة بالذكاء الاصطناعي`,
  p89: `الدخول عن بُعد`,

  p90: `مشمول في الخطة`,

  p91: `السعر سنويًا`,
  p92: `السعر شهريًا`,

  p93: `الحالة`,
  p94: `نشط`,
  p95: `ينتهي`,

  p96: `سجّل وأدِر الغرف المزوّدة بأقفال ذكية. واضبط رموز الدخول التي ستُسلَّم إلى النزلاء.`,

  p97: `روبوت المحادثة بالذكاء الاصطناعي`,
  p98: `أضف خدمة روبوت المحادثة بالذكاء الاصطناعي وأتمت استفسارات نزلائك بسرعة وكفاءة.`,
  
  p99: `هل أنت متأكد من متابعة العملية؟`,
  p100: `تحديث الاشتراك`,

  p101: ``,
  p102: ``,
  p103: ``,
  p104: ``,
  p105: ``,
  p106: ``,
  p107: ``,
  p108: ``,
  p109: ``,
  p110: ``,
  p111: ``,
  p112: ``,
  p113: ``,
  p114: ``,
  p115: ``,
};
